<p-dialog [(visible)]="visible" [width]="width" [closable]="closable" [contentStyle]="contentStyle" [draggable]="false" [resizable]="false"
  [modal]="true" [dismissableMask]="dismissableMask" (onShow)="show.emit()" (onHide)="hide.emit()" [positionTop]="positionTop">
  <p-header>
    {{ header }}
  </p-header>
  <ng-content></ng-content>
  <p-footer>
    <ng-content select="[pmv-footer]"></ng-content>
  </p-footer>
</p-dialog>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵs.html